import { EventObject } from "../../util/event/EventObject";
/**
 * LoaderEvent.ts
 */
export class LoaderEvent {
}
LoaderEvent.PRELOADER_READY = new EventObject("LoaderEvent.PRELOADER_READY");
LoaderEvent.PRELOADER_COMPLETE = new EventObject("LoaderEvent.PRELOADER_COMPLETE");
LoaderEvent.LOADER_READY = new EventObject("LoaderEvent.LOADER_READY");
LoaderEvent.PROGRESS = new EventObject("LoaderEvent.PROGRESS");
LoaderEvent.PROGRESS_COMPLETE = new EventObject("LoaderEvent.PROGRESS_COMPLETE");
LoaderEvent.COMPLETE = new EventObject("LoaderEvent.COMPLETE");
LoaderEvent.LOADER_REMOVE = new EventObject("LoaderEvent.LOADER_REMOVE");
//# sourceMappingURL=LoaderEvent.js.map